const toResponse = accounts => {
  return accounts.map(account => ({
    companyName: account.companyName,
    companyPhone: account.phone,
    accountId: account.accountId,
    streetAddress: account.shippingAddress?.street,
    city: account.shippingAddress?.city,
    state: account.shippingAddress?.state,
    zipCode: account.shippingAddress?.postalCode,
  }));
}

export default toResponse;